
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [validToken, setValidToken] = useState(false);
  const [resetToken, setResetToken] = useState('');
  const navigate = useNavigate();

  // Extract the token from the URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('id');
    if (token) {
      validateToken(token);
      setResetToken(token);
    } else {
      setError('Ungültiger Token.');
    }
  }, []);

  const validateToken = async (token) => {
    try {
      const response = await axios.get(`/api/password-reset/validate-reset-token?id=${token}`);
      console.log('Token validation response:', response.data);
      if (response.data.valid) {
        setValidToken(true);
      } else {
        setError('Der Token ist ungültig oder abgelaufen.');
      }
    } catch (err) {
      setError('Fehler bei der Token-Validierung.');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    try {
      await axios.post('/api/password-reset/reset-password', {
        token: resetToken,
        password,
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError('Fehler beim Zurücksetzen des Passworts. Bitte versuchen Sie es erneut.');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h1 className="card-title">Passwort zurücksetzen</h1>
              {error && <div className="alert alert-danger">{error}</div>}
              {success ? (
                <div className="feedback-success-message" style={{ textAlign: 'center' }}>
                  <div className="checkmark">&#10003;</div>
                  <h3>Passwort erfolgreich zurückgesetzt.<br />Du wirst in Kürze weitergeleitet.</h3>
                </div>
              ) : validToken ? (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="password">Neues Passwort</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Neues Passwort"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirmPassword">Passwort wiederholen</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Passwort wiederholen"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary btn-block">
                    Passwort zurücksetzen
                  </button>
                </form>
              ) : (
                <div className="alert alert-warning">Warte auf Token-Validierung...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
